import PropTypes from "prop-types";
import MDBox from "components/MDBox";

// Borra um bloco do dashboard quando os números são exclusivos do Premium.
// O conteúdo por baixo é fictício (ver data/lockedDashboardData.js).
function LockedBlur({ locked, children }) {
  if (!locked) return children;

  return (
    <MDBox
      aria-hidden="true"
      sx={{ filter: "blur(6px)", pointerEvents: "none", userSelect: "none" }}
    >
      {children}
    </MDBox>
  );
}

LockedBlur.propTypes = {
  locked: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default LockedBlur;
